<template>
  <div class="page-title">
    <h2>{{ title }}</h2>
    <p>{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'PortalPageTitle',
  props: {
    title: String,
    subtitle: String,
  },
};
</script>
